@if (props.prefix || props.suffix) {
  <nz-input-group
    [nzPrefix]="props.prefix"
    [nzSuffix]="props.suffix"
    [nzSize]="props.size ?? 'default'"
  >
    <!-- this input tag must be direct in this level. you can not use a subtemplate - otherwise the Antd internal sibling selector will fail -->
    @if (props.type !== 'number') {
      <input
        nz-input
        [attr.data-test-id]="field.key"
        [formControl]="formControl"
        [type]="props.type || 'text'"
        [formlyAttributes]="field"
        [nzSize]="props.size ?? 'default'"
      />
    } @else {
      <nz-input-number
        [attr.data-test-id]="field.key"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [nzSize]="props.size ?? 'default'"
      />
    }
  </nz-input-group>
} @else {
  @if (props.type !== 'number') {
    <input
      nz-input
      [attr.data-test-id]="field.key"
      [formControl]="formControl"
      [type]="props.type || 'text'"
      [formlyAttributes]="field"
      [nzSize]="props.size ?? 'default'"
    />
  } @else {
    <nz-input-number
      class="w-full"
      [attr.data-test-id]="field.key"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [nzSize]="props.size ?? 'default'"
      [nzControls]="false"
    />
  }
}
